export default __webpack_public_path__ + "static/media/orderOrangeIcon.4836b398.png";